import { useState } from 'react';

import { AxiosPrivate } from '../utils/axios';
import { ResponseException } from '../models';

export const useAddOrganizationUsers = () => {
  const [isFetching, setFetching] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  return {
    errors,
    isFetching,
    success,
    submit: async (organizationId: string, values: any) => {
      setSuccess(false);
      setFetching(true);
      try {
        values.addExistingUsers = values.addExistingUsers.map(uid => {
          return { id: uid };
        });
        const res = await AxiosPrivate.post(`/organizations/${organizationId}/users`, values);
        setSuccess(true);
        setErrors([]);
        return null;
      } catch (e) {
        setSuccess(false);
        setErrors(new ResponseException(e).getErrorMessage());
      } finally {
        setFetching(false);
      }
    },
  };
};
